import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountsLoginService {
  private loginStatusSubject = new BehaviorSubject<boolean>(
    !!sessionStorage.getItem('auth_token')
  );
  loginStatus$ = this.loginStatusSubject.asObservable();

  constructor(private http: HttpClient) {}

  lFN_login(username: string, password: string): Observable<any> {
    const body = {
      username: username,
      password: password,
    };

    return this.http.post<any>(`${environment.ROOT_URL}/auth/sign-in`, body, {
      withCredentials: true,
    });
  }

  lFN_GetSystemParameters() {
    return this.http.get(
      `${environment.ROOT_URL}/jsyogaccounts/systemParameters`,
      { withCredentials: true, responseType: 'text', observe: 'response' }
    );
  }

  lFN_logout() {
    return this.http.get(`${environment.ROOT_URL}/logout`, {
      withCredentials: true,
      responseType: 'text',
      observe: 'response',
    });
  }

  // REQUIRED argument (fixes your error)
  lFN_ConveyLoginStatus(status: boolean): void {
    this.loginStatusSubject.next(status);
  }

  // Optional helper
  isLoggedIn(): boolean {
    return this.loginStatusSubject.value;
  }
}
